import { render, staticRenderFns } from "./usm-fund-facts-panel.vue?vue&type=template&id=593e136c&"
var script = {}
import style0 from "../../../assets/styles/panels/_KeyInformationPanel.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./usm-fund-facts-panel.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports